var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
// Mapping between text-area sizes
var sizeMap = {
    large: {
        sizing: tokens.sizing.large,
        spacingHorizontal: tokens.spacing.medium,
        spacingVertical: '12px',
    },
    medium: {
        sizing: tokens.sizing.medium,
        spacingHorizontal: '12px',
        spacingVertical: '6px',
    },
    small: {
        sizing: tokens.sizing.small,
        spacingHorizontal: '12px',
        spacingVertical: tokens.spacing.xsmall,
    },
};
var textAreaWrapperStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-2px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    position: 'relative',
});
export function textAreaWrapperStyle(_a) {
    var inverted = _a.inverted, isFocusVisible = _a.isFocusVisible;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        textAreaWrapperStaticStyle,
        css(__assign({}, (isFocusVisible && {
            '&::after': {
                boxShadow: "0 0 0 2px ".concat(theme.border.focusOutline),
            },
        }))),
    ], false);
}
var textAreaStaticStyle = css({
    '&::placeholder': {
        color: theme.text.subtle,
        opacity: 1,
    },
    '&:disabled': {
        cursor: 'default',
        opacity: tokens.opacity.high,
    },
    backgroundColor: theme.background.contrast,
    border: "".concat(tokens.borderWidth.thin, " solid ").concat(theme.border.strong),
    borderRadius: tokens.borderRadius.medium,
    color: theme.text.main,
    display: 'block',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.regular,
    height: '100%',
    lineHeight: tokens.lineHeights.relaxed,
    outline: 0,
    resize: 'none',
    width: '100%',
    wordBreak: 'break-word',
});
export function textAreaStyle(_a) {
    var hasError = _a.hasError, size = _a.size;
    return [
        textAreaStaticStyle,
        css(__assign({ fontSize: tokens.fontSizes[size], minHeight: sizeMap[size].sizing, padding: "".concat(sizeMap[size].spacingVertical, " ").concat(sizeMap[size].spacingHorizontal) }, (hasError && {
            borderColor: theme.error.darker,
            boxShadow: "0 0 0 1px ".concat(theme.error.darker),
        }))),
    ];
}
export var growWrapperStyle = css({
    display: 'grid',
});
var fauxGrowElementStaticStyle = css({
    gridArea: '1 / 1 / 2 / 2',
    visibility: 'hidden',
    whiteSpace: 'pre-wrap',
});
export function fauxGrowElementStyle(_a) {
    var size = _a.size;
    return [
        textAreaStaticStyle,
        fauxGrowElementStaticStyle,
        css({
            fontSize: tokens.fontSizes[size],
            padding: "".concat(sizeMap[size].spacingVertical, " ").concat(sizeMap[size].spacingHorizontal),
        }),
    ];
}
export var characterCountStaticStyle = css({
    alignItems: 'center',
    bottom: tokens.spacing.small,
    color: theme.text.subtle,
    display: 'flex',
    lineHeight: tokens.lineHeights.default,
    pointerEvents: 'none',
    position: 'absolute',
    right: '12px',
    zIndex: tokens.zIndex.default,
});
